import { render } from "./TaskCard.vue?vue&type=template&id=9cd9f06c&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"

import "./TaskCard.vue?vue&type=style&index=0&id=9cd9f06c&scoped=true&lang=css"

import exportComponent from "/home/claude/weedborncounty/weedborncounty/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd9f06c"]])

export default __exports__